import {
  HStack,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from '@chakra-ui/react';
import * as React from 'react';

import {
  EditIcon,
  EyeIcon,
  MoreVerticalIcon,
} from '@/imports/ui/chakra/feather';

export const OtherItemsListActions: React.FC<{
  row:any;
  onEdit: (id: string, invNumber: string) => void;
  onView: (id: string) => void;
}> = ({ row, onEdit, onView }) => {

  return (
    <HStack spacing={2} justify="center">
      <Menu placement="bottom-end" autoSelect={false}>
        <MenuButton
          as={IconButton}
          aria-label="Invoice actions"
          size="sm"
          variant="ghost"
          icon={<MoreVerticalIcon boxSize="16px" />}
        />
        <MenuList boxShadow="lg" borderRadius="md">

          <MenuItem
            icon={<EditIcon boxSize="18px" color="primary.500" />}
            onClick={() => onEdit(row._id, row?.invoiceNumber || '')}
          >
            Edit
          </MenuItem>

          <MenuItem
            icon={<EyeIcon boxSize="20px" color="primary.500" />}
            onClick={()=> onView(row._id)}
          >
            View
          </MenuItem>
        </MenuList>
      </Menu>
    </HStack>
  );
};
